<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full"  />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Supplier Status</label>
              <v-select :clearable="true" name="status" placeholder="" v-model="filters['status']" label="name"
                :options="supplier_status_list" :reduce="option => option.value" multiple/>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUNDRY SUPPLIERS">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'sundry-supplier-sheet'" :filters="filters"/>
              <vs-button v-can="'create-edit-sundry-suppliers'" @click="onClickCreateSundrySupplier" class="mr-4" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="sundry-suppliers-list"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="staff"
              @sort="handleSort"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="company_name">COMPANY NAME</vs-th>
                <vs-th width="10%" sort-key="account_number">ACCOUNT NUMBER</vs-th>
                <vs-th width="15%">EMAIL</vs-th>
                <vs-th sort-key="telephone" width="15%">TELEPHONE</vs-th>
                <vs-th width="5%">ACCOUNT CURRENCY</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th sort-key="is_approved" width="10%">SUPPLIER STATUS</vs-th>
                <vs-th width="10%">STATUS CHANGED BY</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickSupplierView(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].account_number">
                    {{ data[indextr].account_number || 'N/A'}}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email}}
                  </vs-td>

                  <vs-td :data="data[indextr].telephone">
                    {{ data[indextr].country_code_telephone}} {{ data[indextr].telephone}}
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0" size="small" class="ml-2" transparent color="#7952B3">
                      {{data[indextr].account_currency }}
                    </vs-chip>
                  </vs-td>


                  <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by}}
                  </vs-td>

                  <vs-td>
                    <vs-chip transparent>
                      {{ data[indextr].status.name || 'N/A' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].approved_by">
                    {{ data[indextr].approved_by || '-'}}
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View" position="left">
                        <vs-button @click.stop="onClickSupplierView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" v-if="[1, 2, 4, 5].includes(data[indextr].status.id)" class="ml-2" text="Approve" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'approve')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" v-if="[1, 3].includes(data[indextr].status.id)" class="ml-2" text="Reject" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'not_approve')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <update-customer-project-brief-pop-up ref="UpdateCustomerProjectBriefPopUp" />

    <create-sundry-supplier-pop-up ref="createSundrySupplierPopUp" />

    <create-formulation-pop-up ref="createFormulationPopUp"/>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const SundrySuppliersRepository = RepositoryFactory.get('sundry')
  import UpdateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/UpdateCustomerProjectBriefPopUp'
  import CreateSundrySupplierPopUp from '@/components/popups/sundry-suppliers/CreateSundrySupplierPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import CreateFormulationPopUp from '@/components/popups/formulations/CreateFormulationPopUp'
  import {defaultPagination, perPageList} from "@/constants/config";


  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        supplier_status_list: [
          { name: 'SAQ Pending', value: 1 },
          { name: 'Pending Approval', value: 2 },
          { name: 'Approved', value: 3 },
          { name: 'Not Approved', value: 4 },
          { name: 'On Hold', value: 5 },
        ]
      }
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerProjectBriefPopUp,
      CreateSundrySupplierPopUp,
      CreateFormulationPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      if (this.$route.query.open ) {
        await this.$refs.UpdateCustomerProjectBriefPopUp.openPopup(this.$route.query.open)
      }
    },
    methods: {
      async refreshData () {
        this.fetchProjectBrief()
      },
      async onClickSupplierView (id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/sundry/${id}`})
      },
      async fetchProjectBrief() {
        await this.$vs.loading({
          container: '#sundry-suppliers-list',
          scale: 0.45
        })
       try {
         const {data} = await SundrySuppliersRepository.getListOfSundrySuppliers(this.page, this.filterQuery, this.perPage, this.sort)
         this.staff =  data.data
         this.meta = data.meta
       } catch (e) {
         this.convertAndNotifyError(e)
       }
        this.$vs.loading.close('#sundry-suppliers-list > .con-vs-loading')
      },

      async onClickCustomerSiteUpdate (id) {
        await this.$refs.UpdateCustomerProjectBriefPopUp.openPopup(id)
      },
      async onClickCreateSundrySupplier () {
        await this.$refs.createSundrySupplierPopUp.openPopup()
      },

      openStatusChangeConfirm (id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: status === 'not_approve' ? 'danger' : 'success',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.changeSundrySupplierStatus,
          parameters: [id, status]
        })
      },
      async changeSundrySupplierStatus (params) {
        this.$vs.loading()
        try {
          await SundrySuppliersRepository.sundrySupplierStatusChange(params[0], params[1])
          this.showSuccessMessage('Sundry supplier status updated!')
          await this.fetchProjectBrief()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      filterQueryUpdate (){
        this.fetchProjectBrief()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProjectBrief()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProjectBrief()
        }

      },
      async onClickCreateFormulation (pb_id) {
        await this.$refs.createFormulationPopUp.openPopup(pb_id)
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      onClickViewRelatedFormula(code) {
        this.$router.push({path: `/pages/formulations?search=${code}`})
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return '#a0937d';
          case 2:
            return 'primary';
          case 3:
            return 'success';
          case 4:
            return 'warning';
          case 5:
            return '#00adb5';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      }

    },
    watch : {
      page(){
        this.fetchProjectBrief()
      },
      perPage() {
        this.fetchProjectBrief()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
